module.exports = __webpack_public_path__ + "01_face.e3a79028.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/girl/layer1/01_face.png
// module id = ohQX
// module chunks = 0